import { call, cancelled, put, takeLatest } from 'redux-saga/effects';
import { apiRequest } from 'utils/request';
import { checkInsSliceActions as actions } from '.';

function* loadBatches() {
  try {
    const payload = yield call(apiRequest, {
      url: `check-in-batches`,
      method: 'get',
    });

    yield put(actions.loadBatchesSuccess(payload));
  } catch (error) {
    yield put(actions.loadBatchesFailed(error.payload));
  } finally {
    if (yield cancelled()) {
    }
  }
}

function* loadEligibleCount() {
  try {
    const payload = yield call(apiRequest, {
      url: `check-in-batches/eligible-count`,
      method: 'get',
    });

    yield put(actions.loadEligibleCountSuccess(payload));
  } catch (error) {
    yield put(actions.loadEligibleCountFailed(error.payload));
  } finally {
    if (yield cancelled()) {
    }
  }
}

function* sendBatch() {
  try {
    const payload = yield call(apiRequest, {
      url: `check-in-batches`,
      method: 'post',
      data: {},
    });

    yield put(actions.sendBatchSuccess(payload));
    yield put(actions.loadBatchesRequest());
  } catch (error) {
    yield put(actions.sendBatchFailed(error.payload));
  } finally {
    if (yield cancelled()) {
    }
  }
}

export function* checkInsSliceSaga() {
  yield takeLatest(actions.loadBatchesRequest.type, loadBatches);
  yield takeLatest(actions.loadEligibleCountRequest.type, loadEligibleCount);
  yield takeLatest(actions.sendBatchRequest.type, sendBatch);
}
